
/**
 * PlantDetailSection - Reusable section component for Plant Detail Dialog
 *
 * Provides consistent styling for content sections with icon, title, and children.
 *
 * @param {Object} props - Component props
 * @param {React.Component} props.icon - Lucide icon component
 * @param {string} props.title - Section title
 * @param {React.ReactNode} props.children - Section content
 */
const PlantDetailSection = ({ icon: Icon, title, children }) => {
  return (
    <div className="mb-6">
      {/* Section Header */}
      <div className="flex items-center gap-2 mb-3 pb-2 border-b border-gray-200">
        {Icon && <Icon className="w-4 h-4 text-gray-700" />}
        <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
      </div>

      {/* Section Content */}
      <div className="pl-6">
        {children}
      </div>
    </div>
  );
};

export default PlantDetailSection;
